import { store } from 'stateManagement/stores/store';

const userAuthorizationService = () => {
    return {
        // getCurrentUserRoles: () => {
        //     return store.getState().authorizationReducer.authorization.roleMember;
        // },
        // getRoleMemberAssignedPermission: () => {
        //     return store.getState().authorizationReducer.authorization.roleMemberAssignedPermission;
        // },
        getUserApplicationPermission: () => {
            return store.getState().authorizationReducer.authorization;
        }
    }
}


export default userAuthorizationService();
